import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import Sidebar from "./Sidebar";
import { API_URL } from "assets/Contsants";

export default function CareerView() {
  const { id } = useParams(); // Get career ID from URL
  const history = useHistory();
  const [career, setCareer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/careers/${id}`)
      .then((response) => {
        setCareer(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching career:", error);
        setError(true);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="text-center text-gray-600">Loading...</p>;
  if (error) return <p className="text-center text-red-500">Career not found</p>;

  return (
    <>
      <div className="parkinsans">
        <div className="flex">
          <div className="xl:w-2/12">
            <Sidebar />
          </div>
          <div className="xl:w-12/12">
            <div className="ml-20">
              <h1 className="text-2xl font-semibold text-black pt-20">Description</h1>
              <div className="mt-8 flex justify-between">
                <div className="xl:w-12/12">
                  <div className="flex">
                    <h1 className="text-lg text-black font-semibold w-48">Name:</h1>
                    <p className="text-lg text-grey">{career.name}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Date of Birth:</h1>
                    <p className="text-lg text-grey">{career.date}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Email:</h1>
                    <p className="text-lg text-grey">{career.email}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Phone Number:</h1>
                    <p className="text-lg text-grey">{career.phone}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Gender:</h1>
                    <p className="text-lg text-grey">{career.gender}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Qualification:</h1>
                    <p className="text-lg text-grey">{career.qualification}</p>
                  </div>
                </div>

                <div className="xl:w-12/12">
                  <div className="flex">
                    <h1 className="text-lg text-black font-semibold w-48">Board:</h1>
                    <p className="text-lg text-grey">{career.board}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Branch:</h1>
                    <p className="text-lg text-grey">{career.branch}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Post Type:</h1>
                    <p className="text-lg text-grey">{career.posttype}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Experience:</h1>
                    <p className="text-lg text-grey">{career.experience}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">State:</h1>
                    <p className="text-lg text-grey">{career.state}</p>
                  </div>

                  <div className="flex mt-6">
                    <h1 className="text-lg text-black font-semibold w-48">Address:</h1>
                    <p className="text-lg text-grey">{career.address}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-2 mr-12 mt-12">
              <a href={career.resume_url} target="_blank">
                <button className="background-blue text-white px-6 py-2 rounded-md">
                  Download Resume
                </button>
              </a>
              <button
                className="background-blue text-white px-12 py-2 rounded-md"
                onClick={() => history.goBack()}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
